import styled from "styled-components";
import {
    INPUT_FIELD_HELPER_TEXT_TYPE,
    INPUT_FIELD_TEXT_COUNT_MODE,
} from "../../../../constants/common.constant";
import {useEffect, useState} from "react";
import {useAppSelector, useAppDispatch} from "../../../../utils/store.utils";
import {selectFXCalculatorForm, selectFXOrderForm, updateFXOrderFormFutureTargetRate} from "../../../../slice/fx";
import {getRateByDealt} from "../../../../formatters/fx";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {FXOrderFormType} from "../../../../types/fx.type";
import {calculateUpperLowerThreshold} from "./services/calculateUpperLowerThreshold";
import useFXCalculator from "../../../../hooks/useFXCalculator";
import form from "../../../../pages/order/form";
import {useNavigate} from "react-router-dom";
import {selectApp} from "../../../../slice/app";
import {AppHistoryType, isWentBackAndToggledFalseEnum} from "../../../../types/app.type";
import {APP_PATH} from "../../../../constants/app.constant";
import {isComeBackFromLatterPage} from "../../../../pages/order/services/isComeBackFromLatterPage";
import {enqueueSnackbar} from "notistack";
import {useIntl} from "react-intl";


interface HelperTextProps {
    helperText?: React.ReactNode;
    helperTextProps?: {
        align?: "left" | "between" | "right";
        type?: INPUT_FIELD_HELPER_TEXT_TYPE;
    };
    textCount?: {
        mode?: INPUT_FIELD_TEXT_COUNT_MODE;
        trim?: boolean;
        limit?: number;
    };
}

interface InputFieldProps extends HelperTextProps {
    fullWidth?: boolean;
    inputProps?: Omit<React.ComponentPropsWithRef<"input">, "value">;
    inputType?: string
}

export const FutureInputField = ({
                                     fullWidth,
                                     inputProps,
                                     helperText,
                                     helperTextProps,
                                     textCount,
                                 }: InputFieldProps) => {
    const fxOrderForm = useAppSelector(selectFXOrderForm);
    const dispatch = useAppDispatch();
    const defaultRate: number = (getRateByDealt(fxOrderForm.source.currency, fxOrderForm.fx) as number) ? (getRateByDealt(fxOrderForm.source.currency, fxOrderForm.fx) as number) : 0;
    const fxTradeForm = useAppSelector(
        selectFXOrderForm
    );
    const app = useAppSelector(selectApp);
    const intl = useIntl();

    const {
        updateFocusingInputAmount,
        handleExchange,
        handleFutureInputChange
    } = useFXCalculator({
        form: "order",
    });

    const inputFieldValueFilter = (fxOrderForm: FXOrderFormType): any => {
        if (fxOrderForm.target.currency) {
            const rate = fxOrderForm.futureTargetRate as string;
            if (rate === "") return ""
            //@ts-ignore
            if (!isNaN(rate!) && rate!.trim() !== "") {
                if (rate!.endsWith('.')) {
                    // Return the rate as a string if it ends with a decimal point
                    return rate;
                } else if (rate!.includes('.')) {
                    const decimalPart = rate.split('.')[1];
                    if (decimalPart.endsWith('0')) {
                        // If the rate ends with a decimal zero, use toFixed
                        const decimalCount = decimalPart.length;
                        const numericRate = Number(rate);
                        return numericRate.toFixed(decimalCount);
                    } else {
                        // If the rate does not end with a decimal zero, return as a number
                        return Number(rate);
                    }
                } else {
                    // If no decimal point, just return the number
                    return Number(rate);
                }
            } else {
                return defaultRate;
            }
        } else {
            return "";
        }
    }


    const inputFieldValueFilter2 = (fxOrderForm: FXOrderFormType): any => {
        if (fxOrderForm.target.currency) {
            const rate = fxOrderForm.futureTargetRate as string;
            // Check if the rate is a valid number or a number ending with a decimal
            // @ts-ignore
            if (!isNaN(rate!) && rate!.trim() !== "") {
                if (rate!.endsWith('.')) {
                    // If rate ends with a decimal point, return as string
                    return rate;
                } else {
                    // Otherwise, convert to number
                    console.log(rate)
                    console.log(Number(rate))
                    const formattedRate = Number(rate).toFixed(5);
                    // return formattedRate;
                    return Number(rate)
                }
            } else {
                return defaultRate;
            }
        } else {
            return "";
        }
    }

    useEffect(() => {

        if (!isComeBackFromLatterPage(app.backFromPath.path) &&
            (app.isWentBackAndToggledFalse === isWentBackAndToggledFalseEnum.FIRST_OPEN_PAGE ||
                app.isWentBackAndToggledFalse === isWentBackAndToggledFalseEnum.MAY_GO_BACK_AGAIN_BUT_HAVE_NOT_TOGGLE
            )
        ) {
            console.log("%cinit rate", "color: red; font-weight: bold;");

            const defaultRate = getRateByDealt(fxOrderForm.source.currency, fxOrderForm.fx);
            dispatch(updateFXOrderFormFutureTargetRate(defaultRate?.toString() as string))
            setTimeout(() => {
                dispatch(updateFXOrderFormFutureTargetRate(defaultRate?.toString() as string));
            }, 300);
        } else if (isComeBackFromLatterPage(app.backFromPath.path)
            && app.isWentBackAndToggledFalse === isWentBackAndToggledFalseEnum.WENT_BACK_AND_TOGGLE_FALSE) {
            console.log("%cinit rate, as went back and toggled false", "color: red; font-weight: bold;");

            const defaultRate = getRateByDealt(fxOrderForm.source.currency, fxOrderForm.fx);
            dispatch(updateFXOrderFormFutureTargetRate(defaultRate?.toString() as string))
            setTimeout(() => {
                dispatch(updateFXOrderFormFutureTargetRate(defaultRate?.toString() as string));
            }, 300);
        } else {
            console.log("don't init... ")
        }
    }, [fxOrderForm.source.currency, fxOrderForm.target.currency]);

    const handleInputChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {

        const inputValue = event.target.value;

        // Function to count the number of decimal places
        const countDecimals = (value: string) => {
            if (value.includes('.')) {
                return value.split('.')[1].length;
            }
            return 0;
        };

        const maxDecimalPlaces = fxOrderForm.fx?.decimalPoint as number;
        const {upperThreshold, lowerThreshold} =
            calculateUpperLowerThreshold(fxOrderForm, defaultRate, maxDecimalPlaces);

        // Regex pattern to validate if the input is a number or a decimal
        const validNumberOrDecimal = /^[0-9]*\.?[0-9]*$/;

        // Check if the input value matches the number or decimal pattern
        if (validNumberOrDecimal.test(inputValue)) {
            // Check if the number of decimal places is within the allowed limit

            if (countDecimals(inputValue) <= maxDecimalPlaces) {
                // Parse the input value for comparison
                const parsedInputValue = parseFloat(inputValue);
                // Check against thresholds and adjust the input value accordingly
                if (parsedInputValue < lowerThreshold) {
                    dispatch(updateFXOrderFormFutureTargetRate(String(lowerThreshold) as string))
                    handleFutureInputChange(fxOrderForm, lowerThreshold)
                } else if (parsedInputValue > upperThreshold) {
                    dispatch(updateFXOrderFormFutureTargetRate(String(upperThreshold) as string))
                    handleFutureInputChange(fxOrderForm, upperThreshold)
                } else {
                    dispatch(updateFXOrderFormFutureTargetRate(inputValue as string))
                    handleFutureInputChange(fxOrderForm, Number(inputValue))
                }
            }
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const countDecimals = (value: string) => {
            if (value.includes('.')) {
                return value.split('.')[1].length;
            }
            return 0;
        };

        // Regex pattern to validate if the input is a number or a decimal
        const validNumberOrDecimal = /^[0-9]*\.?[0-9]*$/;


        const inputValue = event.target.value;
        const maxDecimalPlaces = fxOrderForm.fx?.decimalPoint as number;
        if (validNumberOrDecimal.test(inputValue)) {
            if (countDecimals(inputValue) <= maxDecimalPlaces) {
                dispatch(updateFXOrderFormFutureTargetRate(inputValue as string))
                handleFutureInputChange(fxOrderForm, Number(inputValue))
            }
        }
    };
    const onEnterAndUnfocus = () => {
        const maxDecimalPlaces = fxOrderForm.fx?.decimalPoint as number;
        const {upperThreshold, lowerThreshold} =
            calculateUpperLowerThreshold(fxOrderForm, defaultRate, maxDecimalPlaces);

        if (Number(fxOrderForm.futureTargetRate) < lowerThreshold) {
            console.log("exceed lower bound")
            dispatch(updateFXOrderFormFutureTargetRate(String(lowerThreshold) as string))
            handleFutureInputChange(fxOrderForm, lowerThreshold)
            enqueueSnackbar(
                intl.formatMessage({
                    id: "app.page.orderForm.form.order.label.futureOrder.exceedLowerBound",
                }),
                {variant: "general", mode: "info"}
            );
        } else if (Number(fxOrderForm.futureTargetRate) > upperThreshold) {
            console.log("exceed upper bound")
            dispatch(updateFXOrderFormFutureTargetRate(String(upperThreshold) as string))
            handleFutureInputChange(fxOrderForm, upperThreshold)
            enqueueSnackbar(
                intl.formatMessage({
                    id: "app.page.orderForm.form.order.label.futureOrder.exceedUpperBound",
                }),
                {variant: "general", mode: "info"}
            );
        } else {
            console.log("In the bound")
            dispatch(updateFXOrderFormFutureTargetRate(fxOrderForm.futureTargetRate as string))
            handleFutureInputChange(fxOrderForm, Number(fxOrderForm.futureTargetRate))
        }
    }

    const handleBlur = () => {
        console.log('blur')
        onEnterAndUnfocus()
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            onEnterAndUnfocus()
        }
    };

    return (
        <InputFieldContainer>
            <FutureTargetPriceContainer
                fullWidth={fullWidth}
                helperTextProps={helperTextProps}
            >
                <StaticText>{fxOrderForm.fx && fxOrderForm.target.currency ?
                    `${fxOrderForm.fx.currencies[0]} 1 = ${fxOrderForm.fx.currencies[1]}`
                    :
                    ``
                }
                </StaticText>
                <StyledInputField
                    value={inputFieldValueFilter(fxOrderForm)}
                    type="number"
                    {...inputProps}
                    onChange={handleInputChange}
                    fullWidth={fullWidth}
                    helperTextProps={helperTextProps}
                    disabled={!fxOrderForm.target.currency}
                    onBlur={handleBlur}
                    onKeyPress={handleKeyPress}
                    inputType="number"
                    pattern="[0-9]*[.]?[0-9]*"
                    inputMode="decimal"
                    id={"future-input-field"}
                />
            </FutureTargetPriceContainer>

            {/*<HelperText*/}
            {/*	helperText={helperText}*/}
            {/*	helperTextProps={helperTextProps}*/}
            {/*	textCount={textCount}*/}
            {/*>*/}
            {/*	{helperText}*/}
            {/*	{renderTextCount()}*/}
            {/*</HelperText>*/}
        </InputFieldContainer>
    );
};

export const InputFieldContainer = styled.div``;

const StyledInputField = styled.input<InputFieldProps>`
    border: 0;
    //border-bottom: 1px solid var(--input-border-color);
    border-radius: 0;
    font-family: var(--font-family);
    font-size: 20px;
    font-weight: var(--font-weight-semi-bold);
    line-height: 26px;
    background: none;
    outline: none;
    appearance: none;
    padding: 0px;

    ${({fullWidth}) => fullWidth && `width: 100%;`}

    ${({helperTextProps}) => {
        if (helperTextProps?.type) {
            switch (helperTextProps?.type) {
                case INPUT_FIELD_HELPER_TEXT_TYPE.SUCCESS:
                    return `border-color: var(--input-success-border-color);`;
                case INPUT_FIELD_HELPER_TEXT_TYPE.ERROR:
                    return `border-color: var(--input-error-border-color);`;
            }
        }
    }} // Add onBlur event


    ${({fullWidth}) => fullWidth && `width: 100%;`} ${({helperTextProps}) => {
        if (helperTextProps?.type) {
            switch (helperTextProps?.type) {
                case INPUT_FIELD_HELPER_TEXT_TYPE.SUCCESS:
                    return `border-color: var(--input-success-border-color);`;
                case INPUT_FIELD_HELPER_TEXT_TYPE.ERROR:
                    return `border-color: var(--input-error-border-color);`;
            }
        }
    }}

    ${({inputType}) => inputType && `type: ${inputType};`}

`;


const HelperText = styled.div<HelperTextProps>`
    display: flex;
    margin-bottom: 8px;
    color: var(--text-color-secondary);
    font-size: 12px;
    font-weight: var(--font-weight-light);

    ${({helperText, helperTextProps, textCount}) => {
        if (helperTextProps?.align) {
            if (helperText && textCount) {
                return `justify-content: space-between`;
            } else {
                switch (helperTextProps?.align) {
                    case "between":
                        return `justify-content: space-between`;
                    case "right":
                        return `justify-content: flex-end;`;
                }
            }
        }
    }}
`;

const StaticText = styled.span`
    font-size: 20px;
    color: #cccccc;
    margin-right: 8px;
    font-weight: bold;
    white-space: nowrap;
    padding: 0px;
`;

const FutureTargetPriceContainer = styled.div<InputFieldProps>`
    display: flex;
    margin-bottom: 8px;
    border: 0;
    border-bottom: 1px solid var(--input-border-color);
    border-radius: 0;
    padding: 0 0 8px 0;
    font-family: var(--font-family);
    font-size: 20px;
    font-weight: var(--font-weight-semi-bold);
    line-height: 26px;
    background: none;
    outline: none;
    appearance: none;

    ${({fullWidth}) => fullWidth && `width: 100%;`}


`;


// ${({helperTextProps}) => {
//     if (helperTextProps?.type) {
//         switch (helperTextProps?.type) {
//             case INPUT_FIELD_HELPER_TEXT_TYPE.SUCCESS:
//                 return `color: var(--text-color-green);`;
//             case INPUT_FIELD_HELPER_TEXT_TYPE.ERROR:
//                 return `color: var(--text-color-red);`;
//         }
//     }
// }}

// ${({helperTextProps}) => {
//     if (helperTextProps?.type) {
//         switch (helperTextProps?.type) {
//             case INPUT_FIELD_HELPER_TEXT_TYPE.SUCCESS:
//                 return `border-color: var(--input-success-border-color);`;
//             case INPUT_FIELD_HELPER_TEXT_TYPE.ERROR:
//                 return `border-color: var(--input-error-border-color);`;
//         }
//     }
// }}
